import { gql, DocumentNode } from '@apollo/client';

export const coreSubjectWithStatsFragment = gql`
  fragment CoreSubjectWithStats on SubjectWithStats {
    id: _id
    name
    stats
  }
`;

export const coreSubjectFragment = gql`
  fragment CoreSubject on Subject {
    id: _id
    _id
    name
    course
    parentSubject
  }
`;

export const getSubjectsTreeFragment = (subjectFragment: DocumentNode) => gql`
  fragment SubjectsTree on Subject {
    ...Subject
    subjects @type(name: "Subject") {
      ...Subject
      subjects @type(name: "Subject") {
        ...Subject
      }
    }
  }
  ${subjectFragment}
`;
